import { useMutation } from "@tanstack/react-query";

import { AdminAuthService } from "@/service/api";
import { useSessionStore } from "../store/useSessionStore";

const useRefreshSession = () => {
  const setSession = useSessionStore((state) => state.setSession);

  return useMutation({
    mutationFn: async () => {
      const refreshToken = useSessionStore.getState().session?.refreshToken;
      if (!refreshToken) throw new Error("Sessão inválida.");

      return AdminAuthService.refresh(refreshToken);
    },
    onSuccess: (data) => {
      setSession({ accessToken: data.accessToken, refreshToken: data.refreshToken, user: data.user });
    },
  });
};

export default useRefreshSession;
